var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8297 11.2899L10.5897 7.04995C10.4019 6.86064 10.1463 6.75415 9.8797 6.75415C9.61306 6.75415 9.35747 6.86064 9.1697 7.04995C8.78198 7.43999 8.78198 8.06991 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.78198 15.93 8.78198 16.5599 9.1697 16.9499C9.35842 17.1371 9.6139 17.2415 9.8797 17.2399C10.1455 17.2415 10.401 17.1371 10.5897 16.9499L14.8297 12.7099C15.019 12.5222 15.1255 12.2666 15.1255 11.9999C15.1255 11.7333 15.019 11.4777 14.8297 11.2899Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default ForwardRef;